module.exports = __webpack_public_path__ + "media/AG-Marketing.560a961f.mp4";